import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {FeatureFlagService} from '@app/core/services/feature-flag.service';
import {environment} from '@environments/environment';

export const security2FAGuard: CanActivateFn = () => {
  const featureFlagService = inject(FeatureFlagService);
  const router = inject(Router);
  const security2FAFlag = environment.featureFlagKeys.security2FAFlag?.name ?? '';

  if (featureFlagService.isFlagEnabled(security2FAFlag)()) {
    return true;
  } else {
    router.navigate(['/my-orders']);
    return false;
  }
};
